import React, { Component } from 'react';
import './App.css';
import Login from './screens/Login/Login';
import Dashboard from './screens/Dashboard/Dashboard';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute'
import { AuthProvider } from '../src/components/AuthContext'
import Details from './screens/Form/Details'
import Homepage from './screens/Home/Homepage'
import Team from './screens/Home/Team'
import Generated from './screens/Generated'
import NoPage from './screens/NoPage'
import Terms from './screens/Policy/Terms'
import Privacy from './screens/Policy/Privacy'
// import Loading from './components/Loading'
import ReactGA from 'react-ga'
function initizeAnalytics() {
  ReactGA.initialize("UA-159291325-1")
  ReactGA.pageview('/')
}
class App extends Component {
  render() {
    initizeAnalytics()

    return (
      //any route that should be accessible only once logged in should be placed under privateroute

      <AuthProvider>


        <Router>

          <div className="App">
            <Switch>
              <Route path="/" exact component={Homepage} />
              {/* <Route path="/loading" exact component={Loading} /> */}
              <Route path="/login" exact component={Login} />
              <PrivateRoute path="/detailForm" exact component={Details} />
              <Route path="/team" exact component={Team} />
              <Route path="/nopage" exact component={NoPage} />
              <Route path="/terms" exact component={Terms} />
              <Route path="/privacy" exact component={Privacy} />
              <Route path="/gen" exact component={Generated} />
              <PrivateRoute path="/dashboard" exact component={Dashboard} />
              <Route path="/:username" children={Generated} />
            </Switch>
          </div>
        </Router>
      </AuthProvider>

    );
  }
}
export default App;
